module.exports = __webpack_public_path__ + "static/media/gb.ac47377e.gif";